'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);

var _components = require('../../components');

var _validate = require('../../utils/validate');
var _constants = require('../../constants');

var _ReportIssue = require('./ReportIssue.scss');var styles = _interopRequireWildcard(_ReportIssue);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var requiredFields = ['reason', 'email'];var addressIssueRequiredFields = ['reason', 'issue', 'email'];var omitedKeys = ['issueType'];var

ReportIssue = function (_Component) {_inherits(ReportIssue, _Component);function ReportIssue() {var _temp, _this, _ret;_classCallCheck(this, ReportIssue);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      formData: {
        report_type: _this.props.reportType,
        issueType: _this.props.issueType,
        captcha: null,
        reason: _this.props.issueType === _constants.issueTypes.ADDRESS ? _this.props.issueType : null },

      invalidFields: [] }, _this.











    fetchReCaptchaToken = function (token) {
      _this.setState({ captcha: token }, _this.handleSubmit);
    }, _this.

    handleChange = function (evt) {var _evt$target =
      evt.target,name = _evt$target.name,value = _evt$target.value;
      _this.saveFormData(name, value);
    }, _this.

    saveFormData = function (name, value) {var _Object$assign;
      var invalidFields = [].concat(_this.state.invalidFields);
      var index = invalidFields.indexOf(name);
      var formData = Object.assign({},
      _this.state.formData, (_Object$assign = {}, _Object$assign[
      name] = value, _Object$assign));


      if (index !== -1 && _this.validateField(name, formData)) {
        invalidFields.splice(index, 1);
      }

      _this.setState({
        invalidFields: invalidFields,
        formData: formData });

    }, _this.

    findInvalidRequiredFields = function () {var
      formData = _this.state.formData;
      var fields = _this.props.issueType === _constants.issueTypes.ADDRESS ? addressIssueRequiredFields : requiredFields;
      return fields.filter(function (item) {return !_this.validateField(item, formData);});
    }, _this.

    validateField = function (name, formData) {
      var fieldIsValid = void 0;

      switch (name) {
        case 'email':{
            fieldIsValid = (0, _validate.emailRegexValidation)(formData[name]);
            break;
          }
        default:fieldIsValid = !!formData[name];}


      return fieldIsValid;
    }, _this.

    fieldIsInvalid = function (name) {return _this.state.invalidFields.includes(name);}, _this.
    fieldIsRequired = function (name) {
      var fields = _this.props.issueType === _constants.issueTypes.ADDRESS ? addressIssueRequiredFields : requiredFields;
      return fields.includes(name);
    }, _this.

    handleSubmit = function () {
      var invalidFields = _this.findInvalidRequiredFields();
      _this.setState({ invalidFields: invalidFields });
      if (!invalidFields.length) {
        _this.sendFormData(_this.state.formData);
      }
    }, _this.

    sendFormData = function (data) {var
      captcha = _this.state.captcha;
      var reportIssueData = Object.assign({}, data, { captcha: captcha });var
      userData = _this.props.userData;
      if (userData) {
        reportIssueData.email = data.email || (0, _get2.default)(userData, 'email');
        reportIssueData.name = (0, _get2.default)(userData, 'display_name');
        reportIssueData.user_id = (0, _get2.default)(userData, 'id');
      }
      reportIssueData.email = reportIssueData.email.toLowerCase();
      _this.props.reportIssue((0, _omit2.default)(reportIssueData, omitedKeys));
    }, _this.

    renderForm = function () {var _this$props =
      _this.props,translate = _this$props.translate,issueType = _this$props.issueType;

      return (
        _react2.default.createElement('div', {
            style: { display: _this.props.reportIssues.sent ? 'none' : 'block' },
            className: styles.reportIssues },

          _react2.default.createElement('div', { className: styles.title }, translate('reportIssues', issueType, 'title')),
          _react2.default.createElement(_components.ReportIssueForm, {
            locale: _this.props.locale,
            fetchReCaptchaToken: _this.fetchReCaptchaToken,
            title: translate('reportIssues', issueType, 'message'),
            descriptionPlaceholder: translate('reportIssues', issueType, 'descriptionPlaceholder'),
            emailPlaceholder: translate('reportIssues', 'emailPlaceholder'),
            submitButtonText: translate('reportIssues', 'submitButtonText'),
            reasonPlaceholder: translate('reportIssues', 'reasonPlaceholder'),
            handleChange: _this.handleChange,
            fieldIsInvalid: _this.fieldIsInvalid,
            fieldIsRequired: _this.fieldIsRequired,
            submitForm: _this.handleSubmit,
            showPreloader: _this.props.reportIssues.sending,
            shouldRenderReason: _this.props.issueType !== _constants.issueTypes.ADDRESS })));



    }, _this.

    renderSuccessMessage = function () {return (
        _react2.default.createElement('div', { className: styles.message },
          _react2.default.createElement('p', null, _this.props.translate('contactUsPage', 'formSent')),
          _react2.default.createElement('button', {
              className: 'btn btn-primary',
              onClick: _this.props.hideReportIssueModal },

            _this.props.translate('contactUsPage', 'ok'))));}, _temp), _possibleConstructorReturn(_this, _ret);}ReportIssue.prototype.componentWillMount = function componentWillMount() {document.body.classList.add('fixed-body');};ReportIssue.prototype.componentWillUnmount = function componentWillUnmount() {this.props.resetData();document.body.classList.remove('fixed-body');};ReportIssue.prototype.




  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        this.renderForm(),
        this.props.reportIssues.sent && this.renderSuccessMessage()));


  };return ReportIssue;}(_react.Component);exports.default = ReportIssue;


ReportIssue.propTypes = {
  locale: _propTypes2.default.string,
  issueType: _propTypes2.default.string,
  reportType: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  reportIssue: _propTypes2.default.func,
  resetData: _propTypes2.default.func,
  hideReportIssueModal: _propTypes2.default.func,
  reportIssues: _propTypes2.default.object,
  userData: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportIssue/ReportIssue.js
// module id = 2867
// module chunks = 0